<template>
    <div class="form-label-headline">
        <slot />
    </div>
</template>

<style lang="scss">
.form-label-headline {
    @include form-label;

    width: 100%;
}
</style>
